import React from "react";
import { HashRouter } from "react-router-dom";

import AnimatedRoutes from "./components/AnimatedRoutes";
import ParentCookieConsent from "./components/misc/dsgvo/ParentCookieConsent";

import "./App.css";

const App = () => {
  return (
    <div className="App" id="App">
      {/* The hash router is necessary to add the hash to the url. This is needed due to backend configurations / CORS. */}
      <HashRouter>
        {/* AnimatedRoutes allows animation when transitioning between pages. */}
        <AnimatedRoutes />
      </HashRouter>

      {/* Parent component for the dsgvo cookie note functionality. */}
      <ParentCookieConsent />
    </div>
  );
};

export default App;
